import { Helper } from '../Helper';
export class PutStorageHelper extends Helper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitOp(node, 'TUCK');
        sb.emitHelper(node, options, sb.helpers.cacheStorage);
        sb.emitOp(node, 'SWAP');
        sb.emitOp(node, 'ROT');
        sb.emitOp(node, 'SETITEM');
        sb.emitHelper(node, options, sb.helpers.deleteCacheStorage);
        sb.emitOp(node, 'SWAP');
        sb.emitOp(node, 'REMOVE');
    }
}

//# sourceMappingURL=PutStorageHelper.js.map
